/* eslint-disable @typescript-eslint/no-unused-vars */
import { ApexOptions } from 'apexcharts';

import CardHeader from '@mui/material/CardHeader';
import Card, { CardProps } from '@mui/material/Card';
import { styled, useTheme } from '@mui/material/styles';

import { fNumber } from 'src/utils/format-number';

import Chart, { useChart } from 'src/components/chart';
import Box from '@mui/material/Box';
import { useResponsive } from 'src/hooks/use-responsive';

// ----------------------------------------------------------------------

const CHART_HEIGHT = 291;

const LEGEND_HEIGHT = 91;

const StyledChart = styled(Chart)(({ theme }) => ({
  height: CHART_HEIGHT,

  '& .apexcharts-canvas, .apexcharts-inner, svg, foreignObject': {
    height: `100% !important`,
  },
}));

// ----------------------------------------------------------------------

interface Props extends CardProps {
  title?: string;
  subheader?: string;
  chart: {
    colors?: string[];
    series: {
      label: string;
      value: number;
    }[];
    options?: ApexOptions;
  };
}

export default function AnalyticsPieVisits({ title, subheader, chart, ...other }: Props) {
  const theme = useTheme();

  const { colors, series, options } = chart;
  const smUp = useResponsive('up', 'sm');

  const chartSeries = series.map((i) => i.value);

  const chartOptions = useChart({
    chart: {
      sparkline: {
        enabled: true,
      },
    },
    colors,
    labels: series.map((i) => i.label),
    stroke: {
      colors: [theme.palette.grey[500]],
    },
    legend: {
        formatter: (seriesName: string, opts: any) => {
            if (seriesName) {
                console.log('sdlfhslfi', seriesName);
                console.log('seriesName', seriesName,opts);
                console.log('seriesNameffs', seriesName,opts.seriesIndex,opts.w.globals.series[opts.seriesIndex]);
                return ` ${seriesName}  ${opts.w.globals.series[opts.seriesIndex]}%  `;
            }
            return ''; // Return an empty string instead of null
        },
        position: 'right',
        itemMargin: {
            horizontal: 7,
            vertical: 10,
        },
        labels: {
            colors: colors?.map((i) => i),
        }
    },
    dataLabels: {
      enabled: true,
      dropShadow: {
        enabled: false,
      },
    },
    tooltip: {
      fillSeriesColor: false,
      y: {
        formatter: (value: string | number) => {
          // Ensure we are dealing with a number before we format it
          if (typeof value === 'number') {
            return new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'USD',
              minimumFractionDigits: 0,
            }).format(value);
          }
          return value;
        },
        title: {
          formatter: (seriesName: string) => `${seriesName}`,
        },
      },
    },
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: false,
          },
        },
      },
    },
    ...options,
  });

  return (
    // <Card {...other}>
    //   <CardHeader title={title} subheader={subheader} sx={{ mb: 5 }} />

    <Box
      style={{ marginTop: 0, marginBottom: 0 }}
      sx={{
        my: 5,
        '& .apexcharts-legend': {
          m: 'auto',
          height: { sm: 160 },
          flexWrap: { sm: 'wrap' },
          width: { xs: 240, sm: '50%' },
        },
        '& .apexcharts-datalabels-group': {
          display: 'none',
        },
        '& .apexcharts-legend-marker': {
          height: '16px !important',
          width: '16px !important',
          borderRadius: '0 !important',
        },
      }}
    >
      <StyledChart
        dir="ltr"
        type="pie"
        series={chartSeries}
        options={chartOptions}
        height={smUp ? 240 : 360}
      />
    </Box>
    /* </Card> */
  );
}
